import { render } from "./sic_jobs.vue?vue&type=template&id=38471328&lang=html"
import script from "./sic_jobs.vue?vue&type=script&lang=js"
export * from "./sic_jobs.vue?vue&type=script&lang=js"

import "./sic_jobs.vue?vue&type=style&index=0&id=38471328&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__